import $ from 'jquery';
import listitemlimit from './list-item-limit';

const sectionFilter = function(wrapper, urlHandle) {
    'use strict';

    let $wrapper; // section wrapper
    let pageFilter;
    let dropdowns;
    let filterTagContainer;

    let inputNames;
    let $filterListTarget;
    const filterItems = [];

    const filterNoResultsClass = 'no-result-by-filter';

    const removeAllText = 'Fjern alle';

    /**
     * FILTER DEMO INTEGRATION
     */
    let categoriesOfUsableTags; // Structure example: type: [{ name: 'Blomst', value: 'flower', active: true }, { name: 'plant', active: true },
    const dataset = []; // structure example: { name: 'h�ne', tags: ['bird', 'animal', 'red', 'yellow', 'round', 'triangle'], active: true },
    let choosenTags = [];
    let activeTags = [];
    let numberOfVisibleItems = 0;

    function createFilter(elem) {
        $wrapper = $(elem);
        pageFilter = $wrapper.find('.page-filter');
        if (pageFilter.length < 1) return;

        $filterListTarget = $wrapper.find('[data-filterlist]');
        $filterListTarget.find('[data-tag]').each(function(i, el) {
            filterItems.push($(el));
        });

        dropdowns = $(pageFilter.find('.filter-dropdown[data-category]'));
        filterTagContainer = pageFilter.find('.filter-tags'); // container for tags

        $(pageFilter.find('.filter-dropdown.js-unobtrusive-filter')).each(function() {
            addDropdownToggle(this);

            inputNames = $(this).find('input[type="checkbox"]');

            // checkboxes change
            $(inputNames).change(function(event) {
                if (event.currentTarget.checked) {
                    addTag($(this).attr('value'));
                } else {
                    troelsRemoveTag($(this).attr('value'));
                }
            });
        });

        createFilterInit();
    }

    function createFilterInit() {
        addUIEvents();
        removeUnCheckBoxes(getExistingTagsFromListItems(filterItems));
        removeEmptyDropdowns();

        categoriesOfUsableTags = collectActiveTagsInCategories();
        // build the set of tags that are present in the data, and structure them in the categories from the dropdowns


        // collect data for dataset
        collectDataSet();

        updateTagsFromUI(); // in case some are "checked" because of browser memory on back-button
    }

    /* MODIFIED END */

    function collectDataSet() {
        $filterListTarget.find('[data-tag]').each(function(i, el) {
            const data = {};
            data.element = el;
            data.tags = getTagsFromElement(el);
            data.active = true;
            dataset.push(data);
        });
    }

    function getTagsFromElement(element) {
        const dataTags = $(element).data('tag').split(' ');
        const tags = [];
        dataTags.forEach(function(tag) {
            tags.push(tag);
        });
        return tags;
    }

    function collectActiveTagsInCategories() {
        const filterTagCategories = [];

        dropdowns.each(function() {
            const dd = $(this);
            const tags = dd.find('input').not('.passive').toArray();
            const tagsArray = [];

            tags.forEach(function(element) {
                tagsArray.push({
                    value: $(element).val(),
                    name: $(element).attr('id'),
                    active: true
                });
            });

            const catObj = {
                name: dd.data('category'),
                tags: tagsArray
            };
            if (tagsArray.length > 0) {
                filterTagCategories.push(catObj);
            }
        });
        return filterTagCategories;
    }

    function addTag(tag) {
        choosenTags.push(tag);
        addRemoveTagCommon(tag);
    }

    function troelsRemoveTag(tagToRemove) {
        const newChoosenTags = [];
        choosenTags.forEach(function(tag) {
            if (tag !== tagToRemove) {
                newChoosenTags.push(tag);
            }
        });
        choosenTags = newChoosenTags;
        addRemoveTagCommon(tagToRemove);
    }

    function handleUrlHistory() {

        let query = '';

        if (choosenTags.length === 0) {
            query = '';
        } else {
            query = '?filters=';

            choosenTags.forEach(function (choosenTag, index) {
                query += index !== 0
                    ? ',' + choosenTag
                    : choosenTag;
            });
        }

        if (window.history.pushState) {
            window.history.pushState({}, null, location.pathname + query);
        }

        window.onpopstate = function() {
            updateTagsFromUrl();
            toggleActiveDataAndUpdateVisible();

            console.log('Chosen: ', choosenTags);
        };
    }

    function addRemoveTagCommon(tag) {
        toggleActiveDataAndUpdateVisible();
        collectActiveTags(dataset);

        if (urlHandle) {
            handleUrlHistory();
        }

        if (choosenTags.length === 0) {
            enableEverything();

        } else {
            // deactive tags that are no longer relevant
            const currentCategory = findCurrentCategory(tag, categoriesOfUsableTags);
            deactivateInactiveTagsFromOtherCategories(currentCategory, categoriesOfUsableTags);
        }

        toggleActiveKeys();
        troelsAddTagElements(choosenTags, categoriesOfUsableTags);
        showHideNoResultsAndClearLimit();
    }

    function toggleActiveDataAndUpdateVisible() {
        toggleActiveDataItemsBasedOnTagCategories(dataset, choosenTags, categoriesOfUsableTags);
        updateVisibleData(dataset);
    }

    function toggleActiveKeys() {
        const activeKeys = collectAllActiveKeyValues(categoriesOfUsableTags);
        disableUnCheckBoxes(activeKeys);
    }

    function showHideNoResultsAndClearLimit() {
        // Show / Hide no results/
        if (numberOfVisibleItems < 1) {
            pageFilter.addClass(filterNoResultsClass);
            $('.js-emptyListText').show();
        } else {
            pageFilter.removeClass(filterNoResultsClass);
            $('.js-emptyListText').hide();
        }
        // clear limit
        listitemlimit.clearLimitClass();
    }

    function collectAllActiveKeyValues(categoriesOfTags) {
        const activeKeys = [];
        categoriesOfTags.forEach(function(category) {
            category.tags.forEach(function(tag) {
                if (tag.active) activeKeys.push(tag.value);
            });
        });
        return activeKeys;
    }

    function troelsAddTagElements(tags) {
        clearChoosenTagElements();
        tags.forEach(function(tag) {
            // console.log(tag);
            const tagInput = pageFilter.find('input[value="' + tag + '"]');
            const newTag = $('<div class="filter-tags__tag">' + tagInput.attr('id') + '</div>');
            newTag.on('click', function () {
                troelsRemoveTag(tag);
                tagInput.prop('checked', false);
            });
            filterTagContainer.append(newTag);
        });
    }

    function enableEverything() {
        enableAllDataItems();
        updateVisibleData(dataset);
        clearAllCheckBoxes();
        enableAllTagsInCategory(categoriesOfUsableTags);
        toggleActiveKeys();
        clearChoosenTagElements();
    }

    function clearChoosenTagElements() {
        filterTagContainer.find('.filter-tags__tag:not(.is-static)').remove();
    }

    function clearAllCheckBoxes() {
        inputNames.each(function(i, box) {
            $(box).prop('checked', false);
        });
    }

    function enableAllTagsInCategory(categoriesOfTags) {
        categoriesOfTags.forEach(function(category) {
            category.tags.forEach(function(tag) {
                tag.active = true;
            });
        });
    }

    function findCurrentCategory(choosenTag, categoriesOfTags) {
        let currentCategory;
        categoriesOfTags.forEach(function(category) {
            category.tags.forEach(function(tag) {
                if (choosenTag === tag.value) {
                    currentCategory = category.name;
                }
            });
        });
        return currentCategory;
    }

    function enableAllDataItems() {
        dataset.forEach(function(data) {
            data.active = true;
        });
    }

    // category { tag OR tag OR tag } AND category { tag OR tag OR tag } AND category { tag OR tag OR tag }
    function toggleActiveDataItemsBasedOnTagCategories(dataset, choosenTags) {
        // show all data
        enableAllDataItems();

        // build the category index of the choosen tags
        const choosenTagsInCategories = [];

        let index = 0;
        categoriesOfUsableTags.forEach(function(category) {
            choosenTagsInCategories.push([]);
            category.tags.forEach(function(tag) {
                choosenTags.forEach(function(choosenTag) {
                    if (tag.value === choosenTag) choosenTagsInCategories[index].push(choosenTag);
                });
            });
            index++;
        });

        numberOfVisibleItems = 0;
        // loop over each category of choosen tags and check if the item has at least one tag from each category
        dataset.forEach(function(data) {
            choosenTagsInCategories.forEach(function(choosenTagsFromCategory) {
                let found = false;
                if (choosenTagsFromCategory.length === 0) found = true;
                choosenTagsFromCategory.forEach(function(tag) {
                    data.tags.some(function(dataTag) {
                        if (dataTag === tag) {
                            found = true;
                            return true;
                        }
                    });
                });
                if (!found) {
                    data.active = false;
                }
            });
            if (data.active) numberOfVisibleItems++;
        });
    }

    function updateVisibleData(dataset) {
        dataset.forEach(function(item) {
            if (item.active) {
                showElement(item.element);
            } else {
                hideElement(item.element);
            }
        });
    }

    function hideElement(element) {
        const jqItem = $(element);
        jqItem.detach();
        jqItem.data('filtered', '');
    }

    function showElement(element) {
        const jqItem = $(element);
        jqItem.data('filtered', 'true');
        $filterListTarget.append(jqItem);
    }

    function collectActiveTags(dataset) {
        activeTags = [];
        dataset.forEach(function(data) {
            if (data.active) {
                data.tags.forEach(function(tag) {
                    activeTags.push(tag);
                });
            }
        });
    }

    function deactivateInactiveTagsFromOtherCategories(currentCategory, categoriesOfTags) {
        categoriesOfTags.forEach(function(category) {
            if (category.name !== currentCategory) {
                category.tags.forEach(function(tag) {
                    // loop over alle tags og deaktiver dem der ikke er med i activeTags
                    activeTags.some(function(activeTag) {
                        if (activeTag === tag.value) {
                            tag.active = true;
                            return true;
                        }
                        tag.active = false;
                        choosenTags.forEach(function(choosenTag) {
                            if (tag.value === choosenTag) tag.active = true;
                        });

                    });
                });
            }
        });
    }

    //
    // EXISTING FILTER STARTS HERE
    //

    /**
     * MODIFIED BY TROELS
     */

    function addUIEvents() {
        inputNames = dropdowns.find('input[type="checkbox"]');

        // checkboxes change
        $(inputNames).change(function(event) {
            // updateTagsFromDropdown();
            // console.log(event.currentTarget);
            if (event.currentTarget.checked) {
                addTag($(this).attr('value'));
            } else {
                troelsRemoveTag($(this).attr('value'));
            }
        });
        // dropdown
        dropdowns.each(function() {
            addDropdownToggle(this);
        });
    }

    function updateTagsFromUrl() {
        const url = new URL(window.location.href);
        const filtersValue = url.searchParams.get('filters');
        if (!filtersValue) {
            return;
        }

        const filters = filtersValue.split(',');

        for (let index = 0; index < inputNames.length; index++) {

            const value = $(inputNames[index]).val();

            let chosen = false;
            filters.forEach(function (filter) {
                if (filter === value) {
                    chosen = true;
                }
            });

            let selected = false;
            choosenTags.forEach(function (chosenTag) {
                if (chosenTag === value) {
                    selected = true;
                }
            });

            if (chosen) {
                if (!selected) {
                    addTag(value);
                    $('input[value=' + value + ']').prop('checked', true);
                }
            } else {
                if (selected) {
                    removeTag(value);
                    $('input[value=' + value + ']').prop('checked', false);
                }
            }
        }
    }

    function updateTagsFromUI(){
        $(inputNames).each(function(i, el){
            if (el.checked){
                addTag($(el).val());
            }
        });
    }

    /**
     * MODIFIED END
     */

    function getExistingTagsFromListItems(itemsList) {
        const uniquTags = [];
        itemsList.forEach(function(item) {
            const dataTags = item.data('tag').split(' ');
            dataTags.forEach(function(tag) {
                let exists = false;
                uniquTags.forEach(function(uniq) {
                    if (uniq === tag) {
                        exists = true;
                    }
                });
                if (!exists && tag !== '') {
                    uniquTags.push(tag);
                }
            });
        });
        return uniquTags;
    }

    function collectCheckedTagsInCategories() {
        const filterTagCategories = [];
        dropdowns.each(function() {
            const dd = $(this);
            const tags = dd.find('input:checked').toArray();
            const tagsArray = [];

            tags.forEach(function(element) {
                tagsArray.push({
                    value: $(element).val(),
                    name: $(element).attr('id')
                });
            });

            const catObj = {
                name: dd.data('category'),
                tags: tagsArray
            };
            if (tagsArray.length > 0) {
                filterTagCategories.push(catObj);
            }
        });
        return filterTagCategories;
    }

    function addDropdownToggle(filter) {
        const $dropdown = $(filter);
        const $header = $dropdown.find('.filter-dropdown__title');
        const $contentHeader = $dropdown.find('.filter-dropdown__content-title');
        $header.prop("onclick", null).off("click");
        $header.on('click', toggleOpen);
        $contentHeader.prop("onclick", null).off("click");
        $contentHeader.on('click', toggleOpen);

        function toggleOpen(e) {
            e.stopPropagation();
            $dropdown.toggleClass('filter-dropdown--open');
            $dropdown.siblings().removeClass('filter-dropdown--open');

            if ($dropdown.hasClass('filter-dropdown--open')) {
                $('body').on('click', closeDropdowns);

            } else {
                $('body').off('click', closeDropdowns);
            }
        }
    }

    function closeDropdowns(e) {
        const hasDropDownParent = $(e.target).parents('.filter-dropdown--open').length;
        if (hasDropDownParent === 0) {
            $('.filter-dropdown--open').removeClass('filter-dropdown--open');
        }
    }

    function updateTagsFromDropdown() {
        filterTagContainer.html('');
        const tagCategories = collectCheckedTagsInCategories();

        addTagElements(tagCategories);

        // adds clears limit for "see more" button only if something is choosen
        if (tagCategories.length > 0) {
            listitemlimit.clearLimitClass();
        }
    }

    function addTagElements(tagCategories) {
        tagCategories.forEach(function(category) {
            const tags = category.tags;
            tags.forEach(function(el) {
                const tag = $('<div class="filter-tags__tag">' + el.name + '</div>');
                tag.on('click', function () {
                    troelsRemoveTag(tag);
                });
                filterTagContainer.prepend(tag);
            });
        });
    }

    function removeTag(valueKey) {
        choosenTags.forEach(function (choosenTag, index) {
            if (choosenTag === valueKey) {
                choosenTags.splice(index, 1);
            }
        });

        $('input[value="' + valueKey + '"]').prop('checked', false);
        updateTagsFromDropdown();
    }

    function disableUnCheckBoxes(activeKeys) {
        const disabledList = [];
        inputNames.each(function(i, el) {
            $(el).removeClass('passive');
            $(el).parent('label').removeClass('passive');
            let active = false;
            const inputVal = $(el).val();
            activeKeys.forEach(function(value) {
                if (inputVal === value) {
                    active = true;
                }
            });
            if (!active) {
                disabledList.push(el);
            }
        });

        disabledList.forEach(function(el) {
            $(el).addClass('passive');
            $(el).parent('label').addClass('passive');
        });
    }

    function removeUnCheckBoxes(activeKeys) {
        const disabledList = [];
        inputNames.each(function (i, el) {
            if (!$(el).hasClass('alwaysVisible')) {
                $(el).removeClass('passive');
                let active = false;
                const inputVal = $(el).val();
                activeKeys.forEach(function(value) {
                    if (inputVal === value) {
                        active = true;
                    }
                });
                if (!active) {
                    disabledList.push(el);
                }
            }
        });

        disabledList.forEach(function(el) {
            // $($(el).parent(".filter_dropdown_item")).remove();
            $($(el).parents('.filter_dropdown_item')).css('display', 'none');
        });
    }

    function removeEmptyDropdowns() {
        dropdowns.each(function(i, el) {
            const checkboxes = $(el).find('.filter_dropdown_item');
            let visibleCount = 0;
            checkboxes.each(function(j, item) {
                if ($(item).css('display') !== 'none') {
                    visibleCount++;
                }
            });
            if (visibleCount <= 0) {
                $(el).css('display', 'none');
            }
        });
    }

    createFilter(wrapper);

    if (urlHandle) {
        updateTagsFromUrl();
    }

    function reset() {
        choosenTags = [];
        enableEverything();
        if (urlHandle) {
            handleUrlHistory();
        }

        dropdowns.each(function (i, el) {
            $(el).css('display', '');
            const checkboxes = $(el).find('.filter_dropdown_item');
            checkboxes.each(function (j, item) {
                $(item).css('display', '');
            });
        });

        //close dropdowns
        $('.filter-dropdown--open').removeClass('filter-dropdown--open');
    }

    // TODO : KILA: Discuss with Mithun. Only way I can get access to enableEverything()
    window.app.pagefilterReset = function () {
        reset();
    };
};

function init() {
    const $pagefilters = $('[data-pagefilter]');
    const $filters = $('[data-filterlist]');

    if ($filters.length === 1 || ($filters.length === 0 && $('.js-dropdown-single-select').length >= 1)) {
        sectionFilter($('.main-content'), true);
    } else {
        $pagefilters.each(function (index, domObj) {
            sectionFilter(domObj);
        });
    }
}

function reInit() {
    window.app.pagefilterReset();
    init();
}

export default {
    init,
    reInit
};
